// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file TableContext.ts
 * @input React
 * @output Exports TableContext and TableContextValue
 * @position Context layer; connects Table styling to sub-components (TableRow, TableCell)
 *
 * SYNC: When modified, update these files to stay in sync:
 * - /packages/core/src/Table/Table.tsx (provider)
 * - /packages/core/src/Table/TableRow.tsx (consumer)
 * - /packages/core/src/Table/TableCell.tsx (consumer)
 * - /packages/core/src/Table/index.ts (exports if types change)
 */
import { createContext } from 'react';
export const TableContext = /*#__PURE__*/createContext(null);
TableContext.displayName = 'TableContext';